module.exports = "pegasus/assets/custom-1-google.png";